<ng-progress></ng-progress>
<ng-container *ngIf="authenticatedPageLoaded$ | async">
  <div
    class="ml-5 p-2 justify-content-center d-flex align-items-center gap-3 ng-star-inserted bg-secondary text-white"
    *ngIf="isUserFromTV3"
  >
    <div>
      Do you want to return to Tokeet old version? You can log into Advance CM at any time at
      <a href="http://app.advance.cm">http://app.advance.cm</a>
    </div>
    <a class="btn btn-sm text-dark text-bold" (click)="onReturnToTV3()" style="background: #cdec5e">
      <svg-icon src="/assets/images/icons/return.svg" alt=""></svg-icon>
      <ng-container i18n> Return to Tokeet old version </ng-container>
    </a>
  </div>

  <app-sidebar2></app-sidebar2>
  <app-navbar *ngIf="!isTopNavbarDisabled"></app-navbar>
</ng-container>
<section
  #mainSection
  [ngClass]="appMainClass"
  dropdownScrollContainer
  [style.--top-banner-height.px]="isUserFromTV3 ? 48 : 0"
  [ngStyle]="isHouseStaff ? { top: isUserFromTV3 ? '48' : '0' } : {}"
>
  <ng-container *ngIf="authenticatedPageLoaded$ | async">
    <alert type="warning" class="d-block" *ngIf="isReadonly">
      You don’t have access to change anything on this account
    </alert>
    <alert type="warning" class="d-block" *ngIf="delinquent$ | async">
      <strong>Payment Failed:</strong> Your account is currently delinquent. Please update your card to ensure the
      account is running smoothly.
    </alert>
    <alert type="warning" class="d-block" *ngIf="smartDevicesDelinquent$ | async">
      <strong i18n>Smart Devices Payment Failed:</strong>
      <ng-container i18n>
        We could not charge your Smart Devices subscription. Please update your card to keep smart lock access codes
        working.
      </ng-container>
      <a routerLink="/billing/info" class="alert-link" *ngxPermissionsOnly="['canSeeBilling']" i18n>
        Update card or retry payment
      </a>
      <ng-container *ngxPermissionsExcept="['canSeeBilling']" i18n>
        Please ask your account owner to update the billing details.
      </ng-container>
    </alert>
  </ng-container>
  <router-outlet></router-outlet>
</section>
<ng-container *ngIf="authenticatedPageLoaded$ | async">
  <!-- TV4-5655: disabled - this component eagerly loads all automations + templates on every
       authenticated page (incl. /calendar/multi) to auto-create a default review automation,
       which is costly for large accounts that haven't been set up yet. -->
  <!-- <app-auto-send-review-automation></app-auto-send-review-automation> -->
</ng-container>

<ng-template #onboardingTmpl>
  <app-account-onboarding-popup
    *ngxPermissionsOnly="['canSeeQuickStartGuide']"
    (dismiss)="onDismissOnboarding()"
    cdkDrag
  ></app-account-onboarding-popup>
</ng-template>
